import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: process.env.REACT_APP_GIT_REVISION,
  environment: process.env.REACT_APP_ENV,
  debug: process.env.REACT_APP_ENV === 'development',
  beforeSend: args => {
    if (process.env.REACT_APP_ENV !== 'development') {
      return args
    }
  }
})

export default Sentry



// WEBPACK FOOTER //
// ./src/config/sentry.js